import AddTemplate from "../_templates/AddTemplate";
import { teamSchema } from "../../../schemas/team.schema";
import { createTeam } from "../../../api/coredata.api";

export default function AddTeam() {
  return (
    <AddTemplate
      title="Add Team"
      schema={teamSchema}
      createFn={createTeam}
      redirectPath="/cricket/teams"
    />
  );
}
